'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _titleSection = require('./common/title-section');

var _titleSection2 = _interopRequireDefault(_titleSection);

var _bodySection = require('./common/body-section');

var _bodySection2 = _interopRequireDefault(_bodySection);

var _ctaSection = require('./common/cta-section');

var _ctaSection2 = _interopRequireDefault(_ctaSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'PDF eSignature SEO Page',

    renderTitleSection: function renderTitleSection() {
        var titleSectionProps = {
            title: 'Sign PDFs for Free Using HelloSign',
            subtitle: 'Looking for a free tool to eSign a PDF? HelloSign provides legally binding and secure eSignatures for all your documents.',
            buttonText: 'IT\'S ALWAYS FREE TO TRY!'
        };
        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
    },

    renderBodySection: function renderBodySection() {
        var headerClass = 'm-marketing-page--header';
        var listClass = 'm-marketing-page--list';
        return _jsx(_bodySection2['default'], {}, void 0, _jsx('h2', {
            className: headerClass
        }, void 0, 'How do you sign a PDF without printing?'), _jsx('p', {}, void 0, 'If you want to skip printing, signing, and scanning a document, you can do it all using the ', _jsx('a', {
            href: '/',
            target: '_blank'
        }, void 0, 'HelloSign'), ' eSignature app.'), _jsx('p', {}, void 0, 'Upload your document, sign it, and send it to the intended recipient. You also have the option to send your PDF out with a signature request if you need someone else (or several people!) to sign the document.'), _jsx('h2', {
            className: headerClass
        }, void 0, 'How should you send your eSigned PDF?'), _jsx('p', {}, void 0, 'There are several ways to send an eSigned PDF. You have the following options when you use HelloSign:'), _jsx('ul', {
            className: listClass
        }, void 0, _jsx('li', {}, void 0, 'Send it directly from the eSignature app'), _jsx('li', {}, void 0, 'Download the document and attach it to an email'), _jsx('li', {}, void 0, 'Fax it using our other service, ', _jsx('a', {
            href: 'https://www.hellofax.com',
            target: '_blank'
        }, void 0, 'HelloFax'))), _jsx('h2', {
            className: headerClass
        }, void 0, 'How much does it cost to use HelloSign?'), _jsx('p', {}, void 0, 'HelloSign is an eSignature app where you can sign up to 3 documents per month for free. If you need more documents to be signed or are looking for more features (like templates), a Pro account or higher may be more suitable for you. Check out our ', _jsx('a', {
            href: '/info/pricing',
            target: '_blank'
        }, void 0, 'pricing page'), ' for the features per plan.'), _jsx('h2', {
            className: headerClass
        }, void 0, 'Is this legal?'), _jsx('p', {}, void 0, 'The short answer is, “Yes, it is.” eSignatures are backed by the ESIGN Act of 2000, which gives ', _jsx('a', {
            href: 'http://blog.hellosign.com/esignatures-legal-handwritten-signatures',
            target: '_blank'
        }, void 0, 'eSignatures the same legality as written'), 'signatures.'), _jsx('p', {}, void 0, 'There are certain types of documentation that are not included in the ESIGN Act and must still be signed on paper:'), _jsx('ul', {
            className: listClass
        }, void 0, _jsx('li', {}, void 0, 'Adoption and divorce paperwork'), _jsx('li', {}, void 0, 'Court orders and notices'), _jsx('li', {}, void 0, 'Wills, codicils, and trusts'), _jsx('li', {}, void 0, 'Cancellations of utility services (includes power, water, and heat)'), _jsx('li', {}, void 0, 'Notices of repossession, foreclosure, eviction, or the right to cure'), _jsx('li', {}, void 0, 'Product recalls or material failure'), _jsx('li', {}, void 0, 'Documentation that accompanies hazardous materials, pesticides, or other toxic or dangerous materials')), _jsx('h2', {
            className: headerClass
        }, void 0, 'Can you use Preview or Word instead of an eSignature service to eSign a PDF?'), _jsx('p', {}, void 0, 'Using software such as Preview or Word to sign your document is ', _jsx('strong', {}, void 0, 'not considered a secure method of eSigning'), '. Even though you can paste an image of your signature from a scanned image to get a similar-looking result to an eSignature, these programs don’t provide the security protections that eSignature services do.'), _jsx('p', {}, void 0, 'At HelloSign, we have ', _jsx('a', {
            href: '/info/security',
            target: '_blank'
        }, void 0, 'securities built in'), '. Your documents are encrypted using SSL (Secure Sockets Layer), which is the same level of encryption used by leading banks and government agencies. We also have an audit trail that’s appended to all signature requests so you have record of your business processes.'));
    },

    renderCTASection: function renderCTASection() {
        var ctaSectionProps = {
            title: 'Get started: eSign a document for free',
            subtitle: 'Have a document to sign? Use HelloSign as your PDF eSignature app for free (we even have mobile apps for iOS and Android). If you’re looking for more features for your business (for example, team features, in-person signing, or signer access codes), request a demo with one of our eSignature experts.',
            signupButtonText: 'CREATE A HELLOSIGN ACCOUNT',
            signupButtonUrl: this.props.homeUrl,
            secondButtonText: 'SEE PRO PLANS',
            secondButtonUrl: this.props.pricingUrl,
            apiUsersHeaderText: 'LOOK WHO\'S USING HELLOSIGN',
            embeddedTweetsHeaderText: 'HAPPY TWEETS FROM HAPPY USERS'
        };
        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
    },

    render: function render() {
        return _jsx('div', {}, void 0, this.renderTitleSection(), this.renderBodySection(), this.renderCTASection());
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/pdf-esignature.jsx
 ** module id = 831
 ** module chunks = 0
 **/